function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "25",
  cy: "30",
  r: "2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "14",
  cy: "30",
  r: "2"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M21.164 13H9v9.019C9 23.113 9.908 24 11.027 24h18.086c.834 0 1.582-.498 1.887-1.256v-7.713c0-1.09-.9-1.974-2.014-1.981L21.164 13h0z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M9.016 13.063V8.469L5.111 7.345"
}))));